import React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";

import IDHFormattedMessage from "../IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as AIStarsIcon } from "src/images/ai-stars.svg";
import HorizontalScroller from "../Tabs/components/HorizontalScroller";
import useGetAISuggests from "./useGetAISuggests";
import useAutoHideOnScroll from "./useAutoHideOnScroll";
import Skeleton from "src/app/components/Skeleton/Skeleton";
import {
  openAIChat,
  setAIChatPredefinedPrompt,
} from "src/redux/ai-chat/aiChatActions";
import { getAISuggestsContext } from "./getAISuggestsContext";

import "./AISuggests.scss";

export default function AISuggests() {
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();

  const context = getAISuggestsContext(pathname, search);

  const { data, isLoading } = useGetAISuggests(context);
  const { isHidden, containerRef } = useAutoHideOnScroll(context);

  const renderContent = () => {
    if (isLoading) {
      return [0, 1, 2].map((item) => (
        <Skeleton key={item} width={230} height={36} borderRadius={16} />
      ));
    } else {
      return data.map((item) => (
        <button
          className="button-style-reset ai-suggests__btn"
          key={item.title}
          onClick={() => {
            dispatch(
              setAIChatPredefinedPrompt(item.title, item.predefinedPrompt),
            );
            dispatch(openAIChat());
          }}
        >
          <AIStarsIcon className="ai-suggests__icon" />
          {item.title}
        </button>
      ));
    }
  };

  if (!context) return null;

  return (
    <div
      className={`ai-suggests${isHidden ? " ai-suggests--hidden" : ""}`}
      ref={containerRef}
    >
      <div className="ai-suggests__label">
        <AIStarsIcon />
        <IDHFormattedMessage id="ws_ai_suggests" defaultMessage="AI Suggests" />
      </div>
      <div className="ai-suggests__line" />
      <HorizontalScroller>{renderContent()}</HorizontalScroller>
    </div>
  );
}
